import * as types from 'modules/predefinedMessages/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @type {import('../../../types.js').OpenDuplicateModalPayload} */
const initialState = {};

const setParameters = (_, { payload }) => payload;

const clearState = () => initialState;

export default createReducer(initialState, {
  [types.OPEN_DUPLICATE_MODAL]: setParameters,
  [types.CLOSE_DUPLICATE_MODAL]: clearState,
});
